// Pest control booking (sections/pest-control.liquid): the pincode check, the service choice, the area and
// total for per sq ft services, and the visit time rules. Booking itself is a normal form post to the
// cart; this file only decides when it may go and fills in the "Total Price" line.
// Limit: the pincode check runs in the browser only, the same as live. A server-side check needs an app.

const OPEN_HOUR = 9;
const CLOSE_HOUR = 17;
const MINUTE_MS = 60000;

const form = document.querySelector('[data-pest-form]');
if (form) setUp(form);

function setUp(form) {
  const text = form.dataset;
  const pincodes = new Set(text.pincodes.match(/\d{6}/g));
  const minArea = Number(text.minArea) || 1;
  const $ = (selector) => form.querySelector(selector);
  const pin = $('[data-pin]');
  const pinMsg = $('[data-pin-msg]');
  const details = $('[data-details]');
  const locked = $('[data-locked]');
  const serviceMsg = $('[data-service-msg]');
  const areaField = $('[data-area]');
  const area = $('[data-area-input]');
  const total = $('[data-total]');
  const totalAmount = $('[data-total-amount]');
  const totalInput = $('[data-total-input]');
  const submit = $('[data-submit]');
  const date = $('[data-date]');
  const time = $('[data-time]');
  const visit = $('[data-visit]');
  const submitLabel = submit.textContent;
  let pinOk = false;

  // ok: true (we serve it), false (show an error) or null (still typing: no note yet).
  function setPin(ok, message = '') {
    pinOk = ok === true;
    pinMsg.textContent = message;
    pinMsg.hidden = !message;
    pinMsg.classList.toggle('pest-msg--error', ok === false);
    pin.setAttribute('aria-invalid', String(ok === false));
    details.hidden = !pinOk;
    locked.hidden = pinOk;
  }

  // final: the shopper asked (Check, Enter or Book), so a short pincode gets a note too.
  function checkPin(final) {
    const code = pin.value.trim();
    if (code.length < 6 && !final) return setPin(null);
    if (!/^\d{6}$/.test(code)) return setPin(false, text.pinInvalid);
    if (pincodes.has(code)) return setPin(true, text.pinOk.replace('__PIN__', code));
    return setPin(false, text.pinBlocked);
  }

  function update() {
    const chosen = $('input[name="id"]:checked');
    const perSqft = Boolean(chosen?.hasAttribute('data-per-sqft'));
    // A disabled field is not sent, so fixed-price services go to the cart with quantity 1.
    areaField.hidden = !perSqft;
    area.disabled = !perSqft;
    const quantity = perSqft ? Math.floor(Number(area.value)) || 0 : 1;
    area.setCustomValidity(perSqft && quantity < minArea ? text.areaError : '');
    const amount = chosen && quantity > 0 ? formatMoney((Number(chosen.dataset.price) * quantity) / 100, text.moneyFormat) : '';
    total.hidden = !amount;
    totalAmount.textContent = amount;
    totalInput.value = amount;
    // A no-break space keeps "Rs. 12,000" on one line when the label wraps.
    submit.textContent = amount ? text.submitTotal.replace('__T__', amount.replace(/ /g, '\u00a0')) : submitLabel;
    if (chosen) serviceMsg.hidden = true;
  }

  // Residential or Commercial: show that kind's services and drop a choice the shopper can no longer see.
  function showKind() {
    const kind = $('[data-pest-type]:checked').dataset.pestType;
    form.querySelectorAll('[data-kind]').forEach((group) => {
      group.hidden = group.dataset.kind !== kind;
      if (group.hidden) group.querySelectorAll('input[name="id"]').forEach((input) => { input.checked = false; });
    });
    update();
  }

  // Visits start from the next full hour, in one-hour slots from 9 AM to 5 PM (the live rule). Today's
  // passed slots are switched off; after the last slot has started, the first day is tomorrow.
  function updateVisit() {
    const now = new Date();
    const nextHour = now.getHours() + 1;
    const first = new Date(now);
    if (nextHour >= CLOSE_HOUR) first.setDate(first.getDate() + 1);
    date.min = localDay(first);
    const today = date.value === localDay(now);
    [...time.options].forEach((option) => {
      if (option.value) option.disabled = today && Number(option.value) < nextHour;
    });
    if (time.selectedOptions[0]?.disabled) time.value = '';
    visit.value = date.value && time.value ? visitText(date.value, Number(time.value)) : '';
  }

  // Slot names in the shopper's language ("9 – 10 AM" in English, "9–10 am" in Hindi), from the browser.
  const hourName = new Intl.DateTimeFormat(document.documentElement.lang || 'en', { hour: 'numeric' });
  for (let hour = OPEN_HOUR; hour < CLOSE_HOUR; hour += 1) {
    time.add(new Option(hourName.formatRange(atHour(hour), atHour(hour + 1)), hour));
  }

  pin.addEventListener('input', () => {
    pin.value = pin.value.replace(/\D/g, '').slice(0, 6);
    checkPin(false);
  });
  $('[data-pin-check]').addEventListener('click', () => checkPin(true));
  area.addEventListener('input', update);
  date.addEventListener('change', updateVisit);
  time.addEventListener('change', updateVisit);
  form.addEventListener('change', (event) => {
    if (event.target.matches('[data-pest-type]')) showKind();
    else if (event.target.name === 'id') update();
  });
  // Enter in the pincode box checks it; before an allowed pincode, Enter never books.
  form.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' || !event.target.matches('input')) return;
    if (event.target === pin || !pinOk) {
      event.preventDefault();
      checkPin(true);
    }
  });
  form.addEventListener('submit', (event) => {
    if (!pinOk) {
      event.preventDefault();
      checkPin(true);
      pin.focus();
      return;
    }
    if (!$('input[name="id"]:checked')) {
      event.preventDefault();
      serviceMsg.hidden = false;
      form.querySelector('[data-kind]:not([hidden]) input[name="id"]')?.focus();
      return;
    }
    // A page left open since yesterday: re-check the slot, and stop if it has passed.
    updateVisit();
    if (!form.checkValidity()) {
      event.preventDefault();
      form.reportValidity();
      return;
    }
    // One booking per tap; coming back to the page (back button) unlocks it again.
    submit.disabled = true;
  });
  window.addEventListener('pageshow', () => {
    submit.disabled = false;
    updateVisit();
  });

  // "Book this service" on a service product links here with ?service=<variant id>.
  const wanted = new URLSearchParams(window.location.search).get('service');
  const preset = [...form.querySelectorAll('input[name="id"]')].find((input) => input.value === wanted);
  if (preset) $(`[data-pest-type="${preset.closest('[data-kind]').dataset.kind}"]`).checked = true;
  showKind();
  if (preset) preset.checked = true;
  update();
  updateVisit();
  // The browser may have kept a pincode from before (back button): check it again.
  checkPin(false);
}

/** 9 → a Date at 9:00, only for naming slots. */
function atHour(hour) {
  return new Date(2000, 0, 1, hour);
}

/** A Date → "2026-10-13", the day in the shopper's own time zone, as an <input type="date"> holds it. */
function localDay(day) {
  return new Date(day - day.getTimezoneOffset() * MINUTE_MS).toISOString().slice(0, 10);
}

/** "2026-10-13", 10 → "13-10-2026 (Tue), 10 – 11 AM": the visit as the team reads it on the order. */
function visitText(value, hour) {
  const [year, month, day] = value.split('-');
  const weekday = new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('en-US', { weekday: 'short' });
  const slot = new Intl.DateTimeFormat('en-US', { hour: 'numeric' }).formatRange(atHour(hour), atHour(hour + 1));
  return `${day}-${month}-${year} (${weekday}), ${slot}`;
}

/**
 * 4800 → "Rs. 4,800": an amount in the shop's money format, as Liquid's money filter prints it
 * (no-decimals formats round to whole rupees).
 * Limit: the same rule as formatPrice in predictive-search.js; handles {{amount}} and
 * {{amount_no_decimals}} (this shop's format) only.
 */
function formatMoney(amount, format) {
  return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, name) => {
    const digits = name.includes('no_decimals') ? String(Math.round(amount)) : amount.toFixed(2);
    const [whole, decimals] = digits.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return decimals ? `${grouped}.${decimals}` : grouped;
  });
}
